import type { SVGProps } from 'react'

export const PalleteFilledIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M213.08-188.46v39.61q0 12.91-8.74 21.65-8.73 8.73-21.65 8.73h-34.61q-12.91 0-21.65-8.73-8.73-8.74-8.73-21.65v-63.46q0-15.36 10.41-25.76 10.42-10.39 25.82-10.39h652.28q15.4 0 25.75 10.39 10.34 10.4 10.34 25.76v63.46q0 12.91-8.73 21.65-8.74 8.73-21.65 8.73h-34.61q-12.92 0-21.65-8.73-8.74-8.74-8.74-21.65v-39.61H527.69v39.61q0 12.91-8.73 21.65-8.74 8.73-21.65 8.73h-34.62q-12.91 0-21.65-8.73-8.73-8.74-8.73-21.65v-39.61H213.08Zm43.46-140q-15.37 0-25.76-10.4-10.39-10.39-10.39-25.76v-447.69q0-15.36 10.39-25.76 10.39-10.39 25.76-10.39h446.92q15.37 0 25.76 10.39 10.39 10.4 10.39 25.76v444.62q0 16.67-11.05 27.95-11.06 11.28-27.41 11.28H256.54ZM570-636.92q12.75 0 21.38-8.63 8.62-8.63 8.62-21.39 0-12.75-8.62-21.37-8.63-8.61-21.38-8.61H390q-12.75 0-21.38 8.63-8.62 8.63-8.62 21.38 0 12.76 8.62 21.37 8.63 8.62 21.38 8.62h180Z" />
    </svg>
  )
}
